<br><br><br><br>
<div class="page-title">
  <mat-icon class="app-icon">rubric</mat-icon>
  <h1 class="title-text">Excel Safety Reports</h1>
  <p class="form-desc">Please choose which Safety Form submission data you wish to review, and click below to download a spreadsheet view of the database. You can select 'All Forms' if you need to review them all. (They will not be combined into a single spreadsheet) </p>
</div>
<br>

  <mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" >
        <!-- Office Reporting To -->
        <mat-form-field appearance="fill">
          <mat-label>Safety Form Selection:</mat-label>
          <mat-select formControlName="safetyForm">
            <mat-option value="jsa">JSA</mat-option>
            <mat-option value="jsaPaper">JSA Paper</mat-option>
            <mat-option value="nearMiss">Near Miss</mat-option>
            <mat-option value="goodCatch">Good Catch</mat-option>
            <mat-option value="trainingReq">Training Request</mat-option>
            <mat-option value="allForms">All Forms</mat-option>
          </mat-select>
        </mat-form-field>

        @if (form.get('safetyForm')?.value === 'jsa') {
          <div class="date-range">
            <mat-form-field appearance="fill">
              <mat-label>From Date</mat-label>
              <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" />
              <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
              <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>To Date</mat-label>
              <input matInput [matDatepicker]="toPicker" formControlName="toDate" />
              <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
              <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
          </div>
        }

        <div class="submit-button">
          <button mat-raised-button color="primary" type="submit">Download Data</button>
        </div>
        <div>
        </div>
      </form>
      <br>
      </mat-card-content>
    </mat-card>
    <br><br>
    <hr class="hr">
    <br><br>

    @if (downloadSuccess) {
      <div class="download-success-container">
        <div class="checkmark-circle">
          <div class="checkmark"></div>
        </div>
        <div class="download-message">
          Files downloaded successfully!
        </div>
        <div class="file-list">
          @for (fileName of downloadedFiles; track fileName) {
            <p>{{ fileName }}</p>
          }
        </div>
        <div class="download-help-prompt" (click)="toggleHelpSection()">
          Don't see your file?
        </div>
        @if (showHelpSection) {
          <div class="help-section">
            <div class="images-container">
              <img src="../../../assets/DLdone.PNG" alt="Downloads Folder" class="help-image">
              <img src="../../../assets/dlDone2.PNG" alt="Browser Downloads" class="help-image">
            </div>
            <p>Try checking your browser's download history or navigating to your local downloads folder.</p><br>
            <p>If you still cant find your download, reach out to IT for support.</p>
          </div>
        }
      </div>
    }
